import { Box, Colors, InfoDot, Text } from '@factorialco/deprecated-design-system'

import { track, trackingEvents } from 'modules/core/lib/Tracking'

export interface LegendItem {
  id: string
  label: string
  color: Colors
}

interface Props {
  items: LegendItem[]
  legendAction?: (id: string) => void | null
  activeLegends?: string[]
}

const Legend = ({ items, legendAction, activeLegends = [] }: Props) => {
  const hasActiveLegends = (id: string) => {
    if (!legendAction) return true
    return activeLegends.includes(id)
  }

  return (
    <Box flexDirection="row" gap="s24" height="s24" justifyContent="flexEnd">
      {items.map((item) => {
        const isActiveItem = hasActiveLegends(item.id)

        return (
          <Box
            key={item.label}
            flexDirection="row"
            gap="s8"
            alignItems="center"
            cursor={legendAction ? 'pointer' : 'default'}
            onClick={() => {
              legendAction && legendAction(item.id)

              track(trackingEvents.projectManagement.overview.clickOnHoursEvolutionLegend, {
                data: item.id,
                status: hasActiveLegends(item.label) ? 'shown' : 'hidden',
              })
            }}
          >
            <InfoDot size="medium" color={isActiveItem ? item.color : 'grey400'} />
            <Text.Normal color={isActiveItem ? 'grey800' : 'grey600'} size="100">
              {item.label}
            </Text.Normal>
          </Box>
        )
      })}
    </Box>
  )
}

export default Legend
